import { hasLoadings, hasExclusions } from "@/modules/reports/schemas/utils/"
import get from "lodash.get"
import dayjs from "dayjs"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 1, c: 2 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 9 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template A4 - Number of policies expired, by four Underwriting/ Re-underwriting results, by age and sex of contractInsured Person"
	],
	["Age", "Sex", "Standard Plan", "", "", "", "Flexi Plan"],
	[
		"",
		"",
		"Standard Offer",
		"Offer with Premium Loading Only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE"
	]
]

// Return calculated age
const getAge = policy => {
	const dateOfBirth = get(policy, "contractInsured[0].dateOfBirth", null)
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	for (let i = 1; i < 100; i++) {
		output.push([
			i,
			"M",
			countExpiredStandardOffer(i, "male", payload),
			countExpiredOfferWithLoadings(i, "male", payload),
			countExpiredOfferWithExclusions(i, "male", payload),
			countExpiredOfferWithLoadingsAndExclusions(i, "male", payload)
		])
	}
	for (let j = 1; j < 100; j++) {
		output.push([
			j,
			"F",
			countExpiredStandardOffer(j, "female", payload),
			countExpiredOfferWithLoadings(j, "female", payload),
			countExpiredOfferWithExclusions(j, "female", payload),
			countExpiredOfferWithLoadingsAndExclusions(j, "female", payload)
		])
	}
	return output
}

const countExpiredStandardOffer = (age, gender, payload) => {
	return payload.filter(policy => {
		let contractInsuredAge = getAge(policy)
		let contractInsuredGender = get(policy, "contractInsured[0].gender", null)
		let endDate = get(policy, "endDate", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)

		if (
			policy.status === "ISSUED" &&
			contractInsuredAge === age &&
			contractInsuredGender === gender &&
			dayjs().isAfter(endDate) === true &&
			loadings === false &&
			exclusions === false
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithLoadings = (age, gender, payload) => {
	return payload.filter(policy => {
		let contractInsuredAge = getAge(policy)
		let contractInsuredGender = get(policy, "contractInsured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		let endDate = get(policy, "endDate", null)

		if (
			policy.status === "ISSUED" &&
			contractInsuredAge === age &&
			contractInsuredGender === gender &&
			loadings === true &&
			exclusions === false &&
			dayjs().isAfter(endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithExclusions = (age, gender, payload) => {
	return payload.filter(policy => {
		let contractInsuredAge = getAge(policy)
		let contractInsuredGender = get(policy, "contractInsured[0].gender", null)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		let endDate = get(policy, "endDate", null)

		if (
			policy.status === "ISSUED" &&
			contractInsuredAge === age &&
			contractInsuredGender === gender &&
			exclusions === true &&
			loadings === false &&
			dayjs().isAfter(endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithLoadingsAndExclusions = (age, gender, payload) => {
	return payload.filter(policy => {
		let contractInsuredAge = getAge(policy)
		let contractInsuredGender = get(policy, "contractInsured[0].gender", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		let endDate = get(policy, "endDate", null)

		if (
			policy.status === "ISSUED" &&
			contractInsuredAge === age &&
			contractInsuredGender === gender &&
			loadings &&
			exclusions &&
			dayjs().isAfter(endDate) === true
		) {
			return policy
		}
	}).length
}
